import React, { useState } from 'react'
import { Grid, Paper, TablePagination } from '@material-ui/core'
import PerfectScrollbar from 'react-perfect-scrollbar'

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'
import { Actions } from './components'
import { ChipProgressStatus, ChipStatus, StatusesTab } from '..'

import usePagination from 'hooks/usePagination'
import useFetch from 'hooks/useFetch'

import * as service from 'service'
import constants from 'constants/index'

const MySuppliersTable = ({
  filter,
  preAvaliation = false,
  onRefreshStats = () => {},
}) => {
  const [selectedTab, setSelectedTab] = useState('all')

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(5)

  const { ACTIVE_STATUS, INACTIVE_STATUS } = constants.companySuppliers

  const filterStatus = () => {
    if (selectedTab === 'all') return [ACTIVE_STATUS, INACTIVE_STATUS]

    return selectedTab
  }

  const { response, isLoading, refresh } = useFetch(
    service.dponet.suppliers.clientIndex,
    {
      status: filterStatus(),
      preAvaliation,
      perPage,
      page,
      ...filter.filters,
    },
    [filter.filters, perPage, page, selectedTab],
  )

  const companySuppliers = response?.data?.companySuppliers || []

  const formatCompliance = (compliance) => {
    if (!compliance) return '-'

    return parseFloat(compliance).toFixed(1).replace('.', ',') + '%'
  }

  return (
    <Paper component={Grid} container>
      <Grid item xs={12}>
        <StatusesTab
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          filter={filter}
          preAvaliation={preAvaliation}
          searchField="supplierDocumentOrSupplierName"
        />
      </Grid>
      <Grid item xs={12}>
        <PerfectScrollbar>
          <Table
            emptyMessage={`Nenhum ${
              preAvaliation ? 'pré avaliado' : 'fornecedor'
            } encontrado`}
            isLoading={isLoading}
          >
            <TableHead>
              <TableRow>
                <TableCell>Identificador</TableCell>
                <TableCell>Razão Social</TableCell>
                <TableCell>Documento</TableCell>
                <TableCell align="center">Progresso</TableCell>
                <TableCell>Conformidade</TableCell>
                <TableCell align="center">Status do vínculo</TableCell>
                <TableCell align="right">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {companySuppliers.map((companySupplier) => (
                <TableRow key={companySupplier?.id}>
                  <TableCell>{companySupplier?.id}</TableCell>
                  <TableCell>{companySupplier?.displayName || '-'}</TableCell>
                  <TableCell>{companySupplier?.supplier?.document}</TableCell>
                  <TableCell align="center">
                    {!!companySupplier?.progressStatus ? (
                      <ChipProgressStatus
                        progressStatus={companySupplier?.progressStatus}
                      />
                    ) : (
                      '-'
                    )}
                  </TableCell>
                  <TableCell>
                    {formatCompliance(companySupplier?.complianceGap)}
                  </TableCell>
                  <TableCell align="center">
                    <ChipStatus status={companySupplier?.status} />
                  </TableCell>
                  <TableCell align="right">
                    <Actions
                      companySupplier={companySupplier}
                      refresh={refresh}
                      onRefreshStats={onRefreshStats}
                      preAvaliation={preAvaliation}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={response?.data?.meta?.totalCount || 0}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            page={page - 1}
            rowsPerPage={perPage}
            rowsPerPageOptions={[5, 10, 25, 100]}
            nextIconButtonProps={{ size: 'small' }}
            backIconButtonProps={{ size: 'small' }}
          />
        </PerfectScrollbar>
      </Grid>
    </Paper>
  )
}

export default MySuppliersTable
